exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert.alert-help[data-v-6fd243da]{background:#ffdb9a;color:#2d3e52;margin-left:15px;margin-right:15px}.alert .close[data-v-6fd243da],.info-box .close[data-v-6fd243da]{color:#2d3e52}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fd243da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rebooking/Home.vue
// module id = 503
// module chunks = 0